import { AnyAction } from 'redux';
import { ActionTypes } from '../actions/ActionTypes';
import {
  CategoryTextDto,
  MenuDto,
  PDiPOptionBasicDto,
} from '../../services/Client';

export interface IBaseOptionState {
  serCategories: CategoryTextDto[];
  nonSerCategories: CategoryTextDto[];

  /** PDiP option basic data */
  optionBasicsPDiPList: PDiPOptionBasicDto[];

  /** Extra links for the Base Options area */
  baseOptionsAreaExtraLinks: MenuDto;
}

const INITIAL_STATE: IBaseOptionState = {
  serCategories: [],
  nonSerCategories: [],
  optionBasicsPDiPList: [],
  baseOptionsAreaExtraLinks: {},
};

export const baseOptionReducer = (
  state: IBaseOptionState = INITIAL_STATE,
  action: AnyAction
): IBaseOptionState => {
  switch (action.type) {
    case ActionTypes.SET_SER_CATEGORIES:
      return {
        ...state,
        serCategories: action.data,
      };
    case ActionTypes.SET_NON_SER_CATEGORIES:
      return {
        ...state,
        nonSerCategories: action.data,
      };
    case ActionTypes.SET_OPTION_BASIC_PDIP_LIST:
      return {
        ...state,
        optionBasicsPDiPList: action.data,
      };
    case ActionTypes.RECEIVE_BASE_OPTIONS_AREA_EXTRA_LINKS:
      return {
        ...state,
        baseOptionsAreaExtraLinks: action.baseOptionsAreaExtraLinks,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/baseOptionReducer.ts